import * as React from 'react';
import { MapPageFormFilter } from './Filters';
import { Input } from 'antd';

interface ContractFilterProps extends MapPageFormFilter {
    
}

export default function TreeIdFilter(props: ContractFilterProps) {
  const { value: formValue, onChange: updateForm, isLoading } = props;
  const [value, setValue] = React.useState('');
  
  return (
    <Input
      disabled={isLoading}
      type="text"
      placeholder={'Type tree ID'}
      value={formValue || value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        updateForm && updateForm(e.target.value);
      }}
    />
  );
}